module.exports = __webpack_public_path__ + "img/b2_hanshuangAKM.80c79ea4.jpg";